export {default} from './compare-cars-container';
export const path = "/compare";